import { createFileRoute, notFound } from '@tanstack/react-router'
import { THIRD_PARTY_PUBLIC } from '@/lib/third-party'
import { ThirdPartyMonitoringPage, featurePageHead } from '@/components/third-party-marketing/feature-page'

export const Route = createFileRoute('/_site/features/third-party-monitoring')({
  // Not public until the owner flips THIRD_PARTY_PUBLIC (src/lib/third-party.ts). While it is false
  // the page copy is not imported by the route, so the build leaves it out of the bundles.
  beforeLoad: () => {
    if (!THIRD_PARTY_PUBLIC) throw notFound()
  },
  component: THIRD_PARTY_PUBLIC ? ThirdPartyMonitoringPage : undefined,
  head: THIRD_PARTY_PUBLIC ? featurePageHead : undefined,
})
